import { load } from "@nextgisweb/jsrealm/i18n/catalog";
load("mapserver", {"":{"MapServer style":["Стиль MapServer"],"XML syntax error: %s":["Синтаксическая ошибка XML: %s"],"XML schema error: %s":["Ошибка схемы XML: %s"]}})